import { FC, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSuccessfulCreateSnackbar, useFailedCreateSnackbar, LoadingIndicator } from '../../../../Components/CoreLib/library';
import { MaterialLineItemDto } from '../../../../dtos';
import { useCreateMaterialLineItemMutation, useLazyGetOrderByIdQuery, useLazyGetQuoteByIdQuery } from '../../../../store/generated/generatedApi';
import { MaterialLineItemForm } from '../../../../Components/Forms/QuoteForm/LineItemForms/MaterialLineItem/MaterialLineItemForm';
import { DEFAULT_MATERIAL_LINE_ITEM } from '../../../../Components/Forms/QuoteForm/LineItemForms/MaterialLineItem/useMaterialLineItemForm';

export const AddMaterialLineItemView: FC = () => {
    const { quoteId, jobId, orderId } = useParams();
    const navigate = useNavigate();
    const [getQuote, { data: quote, isLoading: isQuoteLoading }] = useLazyGetQuoteByIdQuery();
    const [createMaterialLineItem, { isError, isSuccess, reset }] = useCreateMaterialLineItemMutation();
    const [getOrder, { data: order, isLoading: isOrderLoading }] = useLazyGetOrderByIdQuery();

    useEffect(() => {
        if (quoteId && !quote) {
            getQuote({ id: quoteId! });
        }
    }, [getQuote, quote, quoteId]);

    useEffect(() => {
        if (orderId && !order) {
            getOrder({ id: orderId! });
        }
    }, [getOrder, order, orderId]);

    useSuccessfulCreateSnackbar('Material Line Item', isSuccess, () => {
        if (orderId || jobId) {
            navigate(`/job/${jobId}/order/${order?.id ?? 'create'}`);
        } else if (quoteId) {
            navigate(`/quote/${quoteId}/lineItems`);
        } else {
            navigate(`/quotes`);
        }
    });
    useFailedCreateSnackbar('material line item', isError, reset)

    const handleSave = (values: MaterialLineItemDto) => {
        createMaterialLineItem(values);
    };

    const handleCancel = () => {
        if (orderId || jobId) {
            navigate(`/job/${jobId}/order/${order?.id ?? 'create'}`);
        } else if (quoteId) {
            navigate(`/quote/${quoteId}/lineItems`)
        } else {
            navigate('/quotes');
        }
    };

    if (isQuoteLoading || isOrderLoading || quote === undefined) {
        return <LoadingIndicator />;
    }

    return <MaterialLineItemForm save={handleSave} cancel={handleCancel} quote={quote} order={order} initValues={DEFAULT_MATERIAL_LINE_ITEM} />;
};
